export * from './calendar.base';

export const prependCalendarIconToDatePickerBtn = () => {
  const icon = document.createElement('i');
  icon.classList.add('fas', 'fa-calendar', 'mr-2', 'text-neutral-120');

  const button: HTMLButtonElement | null = document.querySelector('.fc-datePickerButton-button');
  const hasIcon = !!button?.querySelector('i.fas');

  if (!hasIcon) {
    button?.prepend(icon);
  } else {
    const hasCorrectIcon = !!button?.querySelector('i.fa-calendar');
    if (!hasCorrectIcon) {
      button?.querySelector('i.fas')?.remove();
      button?.prepend(icon);
    }
  }
};

export const prependCalendarIconToIcsBtn = () => {
  const icon = document.createElement('i');
  icon.classList.add('fas', 'fa-calendar-plus', 'text-neutral-120');

  const button: HTMLButtonElement | null = document.querySelector('.fc-faCalendarPlus-button');
  const hasIcon = !!button?.querySelector('i.fas');

  if (!hasIcon) {
    button?.prepend(icon);
  } else {
    const hasCorrectIcon = !!button?.querySelector('i.fa-calendar-plus');
    if (!hasCorrectIcon) {
      button?.querySelector('i.fas')?.remove();
      button?.prepend(icon);
    }
  }
};

export const prependPlusIconMyWorkplace = () => {
  const icon = document.createElement('i');
  icon.classList.add('fas', 'fa-plus', 'mr-2', 'text-white');

  const button: HTMLButtonElement | null = document.querySelector('.fc-myWorkplaceButton-button');
  const hasIcon = !!button?.querySelector('i.fas');

  if (!hasIcon) {
    button?.prepend(icon);
  } else {
    const hasCorrectIcon = !!button?.querySelector('i.fa-plus');
    if (!hasCorrectIcon) {
      button?.querySelector('i.fas')?.remove();
      button?.prepend(icon);
    }
  }
};
